import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNumbers } from '../context/NumberContext';

export default function NoNumberGuard({ children }) {
  const { businesses, activeBusiness, numbers, activeNumber, loaded } = useNumbers();
  const navigate = useNavigate();

  if (!loaded) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <div style={{ color: 'var(--text3)', fontSize: 13 }}>Loading…</div>
      </div>
    );
  }

  if (businesses.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100%', gap: 16, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 52 }}>🏢</div>
        <div style={{ fontSize: 17, fontWeight: 600 }}>No Business Added</div>
        <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 340, lineHeight: 1.7 }}>
          Add a WhatsApp Business Account first, then add phone numbers under it.
        </div>
        <button className="btn-primary" onClick={() => navigate('/businesses')}>🏢 Add Business →</button>
      </div>
    );
  }

  if (!activeBusiness) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100%', gap: 16, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 52 }}>🏢</div>
        <div style={{ fontSize: 17, fontWeight: 600 }}>Select a Business</div>
        <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 340, lineHeight: 1.7 }}>
          Choose a business from the sidebar dropdown to continue.
        </div>
        <button className="btn-primary" onClick={() => navigate('/businesses')}>Manage Businesses →</button>
      </div>
    );
  }

  if (numbers.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100%', gap: 16, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 52 }}>📱</div>
        <div style={{ fontSize: 17, fontWeight: 600 }}>No Phone Numbers</div>
        <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 340, lineHeight: 1.7 }}>
          Add at least one phone number to <strong>{activeBusiness.label}</strong>.
        </div>
        <button className="btn-primary" onClick={() => navigate('/businesses')}>📱 Add Number →</button>
      </div>
    );
  }

  if (!activeNumber) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100%', gap: 16, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 52 }}>📲</div>
        <div style={{ fontSize: 17, fontWeight: 600 }}>Select a Number</div>
        <div style={{ fontSize: 13, color: 'var(--text2)', maxWidth: 340, lineHeight: 1.7 }}>
          Choose a phone number from the sidebar to continue.
        </div>
        <button className="btn-primary" onClick={() => navigate('/businesses')}>Manage Numbers →</button>
      </div>
    );
  }

  return children;
}
